import { 
  Eye, TrendingUp, Minus, Pen, Smile, EyeOff, 
  Hand, Footprints, Sparkles, Scissors, Droplet
} from 'lucide-react';
import { TreatmentCategory } from '../types';

interface CategorySelectorProps {
  onSelect: (category: TreatmentCategory) => void;
}

const categories = [
  { id: 'pestanas' as TreatmentCategory, name: 'Pestañas', Icon: Eye },
  { id: 'lifting' as TreatmentCategory, name: 'Lifting', Icon: TrendingUp },
  { id: 'cejas' as TreatmentCategory, name: 'Cejas', Icon: Minus },
  { id: 'micropigmentacion-cejas' as TreatmentCategory, name: 'Micropigmentación de Cejas', Icon: Pen },
  { id: 'micropigmentacion-labios' as TreatmentCategory, name: 'Micropigmentación de Labios', Icon: Smile },
  { id: 'micropigmentacion-ojos' as TreatmentCategory, name: 'Micropigmentación de Línea de Ojos', Icon: EyeOff },
  { id: 'manicura' as TreatmentCategory, name: 'Manicura', Icon: Hand },
  { id: 'pedicura' as TreatmentCategory, name: 'Pedicura', Icon: Footprints },
  { id: 'tratamientos-faciales' as TreatmentCategory, name: 'Tratamientos Faciales', Icon: Sparkles },
  { id: 'tinte-cabello' as TreatmentCategory, name: 'Tinte de Cabello', Icon: Droplet },
  { id: 'corte-pelo' as TreatmentCategory, name: 'Corte de Pelo', Icon: Scissors }
];

export function CategorySelector({ onSelect }: CategorySelectorProps) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
      {categories.map(({ id, name, Icon }) => (
        <button
          key={id}
          onClick={() => onSelect(id)}
          className="flex flex-col items-center justify-center gap-3 p-6 bg-white rounded-xl border-2 border-gray-100 hover:border-[#E91E8C] hover:bg-[#E91E8C]/5 transition-all active:scale-95"
        >
          <div className="w-14 h-14 rounded-full bg-[#E91E8C]/10 flex items-center justify-center">
            <Icon className="w-7 h-7 text-[#E91E8C]" />
          </div>
          <span className="text-sm font-medium text-center text-[#2d2d2d]">
            {name}
          </span>
        </button>
      ))}
    </div>
  );
}